
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

import Picker from '../Picker'
import PickersList from '../PickersList'

import ColorRound from './ColorRound'
import translations from './PickerColor.translations'

const MAX_COLORS = 6
const MAX_COLORS_MOBILE = 6

export default {
  components: {
    PickersList,
    Picker,
  },

  props: {
    activeBackboxGrade: {
      type: Number,
      default: 0,
    },
    displayVariant: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    clickOnLinkPicker: {
      type: Function,
      default: () => {},
    },
    loadingId: {
      type: String,
      default: null,
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },

  computed: {
    translations: () => translations,
    ColorRound: () => ColorRound,

    ...mapGetters({
      breakpoint: 'breakpoint',
    }),

    displayColors() {
      return this.displayVariant && !isEmpty(this.colors)
    },

    isMobile() {
      return this.breakpoint < 3
    },

    shownColors() {
      if (this.isMobile) {
        return MAX_COLORS_MOBILE
      }
      // fallback on desktop to avoid visible flickering

      return MAX_COLORS
    },

    colorsWithLink() {
      return this.colors.map((color) => ({
        ...color,
        link: {
          ...color.link,
          hash: { l: this.activeBackboxGrade, scroll: false },
        },
        isLoading: color.id === this.loadingId,
      }))
    },

    hasLoadingId() {
      return this.loadingId !== null
    },
  },

  methods: {
    colorClick({ selected, name, id }) {
      if (!selected) {
        trackClick({ zone: 'color_picker', name })
      }
      this.clickOnLinkPicker(id)
    },
  },
}
